import programacaoAbate from "@/modules/programacaoAbate/pages/programacaoAbate"

export default [
    {
        path: '/programacaoAbate',
        name: 'programacaoAbate',
        component: programacaoAbate
    }
]